import {httpUrl} from './httpUrl'

let baseUrl = `${httpUrl.host}/gy-auth`
// let baseUrl = '/api/yq-auth'
let baseUrl2 = `${httpUrl.host}/gy-apartment`

let api = {
  // 获取验证码
  getIdentityCode: `${baseUrl}/getIdentityCode`,

  // 登录
  login: `${baseUrl}/login`,

  // 免登录（海南）
  loginFree: `${baseUrl}/loginForTest`,

  // 免登录（公寓）
  loginForAvoid: `${baseUrl}/loginForAvoid`,

  // 退出
  logout: `${baseUrl}/logout`,

  // 获取园区信息
  getYqInfo: `${baseUrl2}/yqInfo/getYqInfo`,

  // 获取账户手机号
  getPhone: `${baseUrl}/resetPassWord/getPhone`,

  // 发送短信
  sendVerificationCode: `${baseUrl}/resetPassWord/sendVerificationCode`,

  // 校验短信
  checkVerificationCode: `${baseUrl}/resetPassWord/checkVerificationCode`,

  // 修改密码
  resetPassWord: `${baseUrl}/resetPassWord/reset`,

  // 修改子账号密码
  changePassword: `${baseUrl}/account/changePassword`,

  // 查询微信关联账号列表
  getAccountByWx: `${baseUrl}/wx/wxQrcodeLogin/getAccount`,

  // 选择账号登录
  chooseAccountThenLogin: `${baseUrl}/wx/wxQrcodeLogin/chooseAccountThenLogin`,

  // 关联账号登录
  bindAccountThenLogin: `${baseUrl}/wx/wxQrcodeLogin/bindAccountThenLogin`,

  // 判断是否拥有公寓账号
  getApartmentMeg: `${baseUrl}/signIn`,

  // 免登录跳转
  bindLogin: `${baseUrl}/accountBind/bindLogin`,
}

export {api}



// WEBPACK FOOTER //
// ./src/view/api/Login.js